import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_RATES = {
  USD: { symbol: "$", rate: 1.0, label: "US Dollar" },
  EUR: { symbol: "\u20ac", rate: 0.92, label: "Euro" },
  GBP: { symbol: "\u00a3", rate: 0.78, label: "Pound Sterling" },
  CAD: { symbol: "CA$", rate: 1.37, label: "Canadian Dollar" },
  AUD: { symbol: "A$", rate: 1.51, label: "Australian Dollar" },
  BRL: { symbol: "R$", rate: 5.42, label: "Brazilian Real" },
};

const FALLBACK_PRODUCTS = [
  {
    slug: "fight-studio",
    name: "Orvyn Fight Studio",
    version: "v4.2.0",
    kind: "Standalone script",
    price: 14.99,
    currency: "USD",
    available: false,
  },
  {
    slug: "karate-gi",
    name: "Orvyn Karate Female and Male GI's",
    version: "8 gis",
    kind: "Add-on clothing",
    price: 4.99,
    currency: "USD",
    available: false,
  },
];

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [rates, setRates] = useState(FALLBACK_RATES);
  const [products, setProducts] = useState(FALLBACK_PRODUCTS);
  const [code, setCode] = useState(() => localStorage.getItem("orvyn_currency") || "USD");

  useEffect(() => {
    axios
      .get(`${API}/currency-rates`)
      .then(({ data }) => data?.rates && setRates(data.rates))
      .catch(() => {});
    axios
      .get(`${API}/products`)
      .then(({ data }) => data?.products?.length && setProducts(data.products))
      .catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("orvyn_currency", code);
  }, [code]);

  const value = useMemo(() => {
    const entry = rates[code] || FALLBACK_RATES.USD;
    const format = (usd) => `${entry.symbol}${(usd * entry.rate).toFixed(2)}`;
    return {
      code,
      setCode,
      rates,
      symbol: entry.symbol,
      isBase: code === "USD",
      format,
      products,
      product: (slug) => products.find((p) => p.slug === slug) || FALLBACK_PRODUCTS[0],
    };
  }, [code, rates, products]);

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};

export const useStore = () => {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error("useStore must be used inside StoreProvider");
  return ctx;
};
